export default {
  cancelTitle: '21022019-105513-0001',
  cancellationFeeIs: '21022019-105513-0002',
  chargeWarning: '21022019-105513-0003',
  cancellationFullDetails: '21022019-105513-0004',
  cancelBookingLabel: '21112016-163217-2284',
  cancellationConfirmed: '21022019-105513-0005',
  bookingReviewTitle: '21022019-105513-0006',
  bookedBy: '08122016-132430-9281',
  bookingReference: '21022019-105513-0007',
  confirmCancellation: '21022019-105513-0008',
  pleaseConfirmCancellation: '21022019-105513-0009',
  goBack: '21022019-105513-0010',
  cancelBooking: '21112016-163217-2284',
  cannotCancelBooking: '21022019-105513-0011',
};
